<div class="new-order">
  <img src="../../../../assets/restaurant-bell.png" width="200" alt="resturant-bell" />
  <h4>{{ data.body }}</h4>
  <button class="p-button" (click)="goToOrder()">Go To Order</button>
</div>
